import Carousel from './Carousel';

export default Carousel;


// WEBPACK FOOTER //
// ./src/components/Carousel/index.tsx